import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DeviceInfoService } from '@core/services/device-info.service';
import { ConfirmationModalComponent } from './confirmation-modal.component';
import { MobileDialogBackButtonData } from '@shared/mobile-dialog-back-button.service';

export interface ModalOpts extends MobileDialogBackButtonData {
  titleTranslated?: string;
  titleToTranslate?: string;
  confirmationTranslated?: string;
  confirmationToTranslate?: string;
  translateParams?: { [key: string]: any };
  yesButtonKey?: string;
  yesButtonIcon?: string;
  noButtonKey?: string;
  additionalMessage?: boolean;
  initialValue?: any;
  autofocus?: boolean;
  width?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmationModalService {
  private readonly dialog = inject(MatDialog);
  private readonly deviceInfoService = inject(DeviceInfoService);
  private readonly mobileDialogWidth = 'calc(100vw - 32px)';
  private readonly mobileDialogMaxHeight = 'calc(100dvh - 32px)';
  public name = 'confirmation-modal';

  public open(opts: ModalOpts): MatDialogRef<ConfirmationModalComponent> {
    const { deviceTypeDetected } = this.deviceInfoService.getInfo();
    const isPhone = deviceTypeDetected === 'PHONE';
    let dialogWidth = opts.width || '500px';

    if (deviceTypeDetected !== 'DESKTOP') {
      dialogWidth = this.mobileDialogWidth;
    }

    return this.dialog.open(ConfirmationModalComponent, {
      width: dialogWidth,
      maxWidth: dialogWidth,
      ...(isPhone ? { maxHeight: this.mobileDialogMaxHeight } : {}),
      panelClass: ['confirmation-modal'],
      data: { ...opts },
      autoFocus: opts.autofocus || false,
      backdropClass: ['user-process-modal-backdrop', this.name + '_backdrop'],
    });
  }
}
